module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-200.6e5886a6.woff2";